const header = document.querySelector("header");
const menuMobItems = [...document.querySelectorAll("header .nav")];
const menuMob = menuMobItems[0] || null;
const toggleMenu = document.querySelector("#toggleMenu");
const htmlOpen = document.documentElement;
let menuTrigger = null;
let mobileMenuTimeline = null;

let headerHeight = header ? header.offsetHeight : 0;
const mobileMenuQuery = window.matchMedia("(max-width: 768px)");
function initSmoothPageScroll() {
	const canUseSmoothScroll = typeof Lenis !== "undefined"
		&& window.matchMedia("(pointer: fine)").matches
		&& !window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	if (!canUseSmoothScroll) {
		return;
	}

	const lenis = new Lenis({
		lerp: 0.16,
		smoothWheel: true,
		wheelMultiplier: 0.9,
		syncTouch: false,
	});


	function smoothScrollFrame(time) {
		lenis.raf(time);
		requestAnimationFrame(smoothScrollFrame);
	}

	requestAnimationFrame(smoothScrollFrame);
}

const sectionOffset = 32;
const servicesCardsQuery = window.matchMedia("(max-width: 1180px)");

function updateHeaderHeight() {
	headerHeight = header ? header.offsetHeight : 0;
}

function resetMobileMenuVisualState() {
	menuMobItems.forEach((menu) => menu.classList.remove("open", "is-closing"));
}

function getMobileMenuLinks() {
	return menuMobItems.flatMap((menu) => [...menu.querySelectorAll("a")]);
}

function getMobileMenuTimeline() {
	if (!mobileMenuQuery.matches || !menuMob || typeof gsap === "undefined") {
		return null;
	}

	if (mobileMenuTimeline) {
		return mobileMenuTimeline;
	}

	if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
		return null;
	}

	const links = getMobileMenuLinks();
	mobileMenuTimeline = gsap.timeline({
		paused: true,
		onComplete: () => menuMob.querySelector("a")?.focus(),
		onReverseComplete: () => {
			resetMobileMenuVisualState();
			htmlOpen.classList.remove("menu-active");
		},
	});

	mobileMenuTimeline.fromTo(
		links,
		{ autoAlpha: 0, x: -28, clipPath: "inset(0 100% 0 0)" },
		{ autoAlpha: 1, x: 0, clipPath: "inset(0 0% 0 0)", duration: 0.44, stagger: 0.07, ease: "power3.out" },
	);

	return mobileMenuTimeline;
}

function setMobileMenusInert(isInert) {
	menuMobItems.forEach((menu) => {
		menu.inert = isInert;
	});
}

function closeMobileMenu({ restoreFocus = false } = {}) {
	if (!menuMob || !toggleMenu) {
		return;
	}

	const wasOpen = menuMobItems.some((menu) => menu.classList.contains("open"));
	toggleMenu.classList.remove("active");
	toggleMenu.setAttribute("aria-expanded", "false");
	toggleMenu.setAttribute("aria-label", "Abrir menu");
	setMobileMenusInert(mobileMenuQuery.matches);

	const timeline = getMobileMenuTimeline();
	if (wasOpen && timeline && timeline.progress() > 0) {
		menuMobItems.forEach((menu) => menu.classList.add("is-closing"));
		timeline.reverse();
	} else {
		resetMobileMenuVisualState();
		htmlOpen.classList.remove("menu-active");
	}

	if (restoreFocus && menuTrigger) {
		menuTrigger.focus();
	}
}

let lastScrollY = window.scrollY;
let hideTimeout = null;
const hideDelay = 300;

function setHeaderSticky() {
	if (!header) {
		return;
	}

	const currentScrollY = window.scrollY;
	const isFixed = currentScrollY > 0;
	const isMenuOpen = menuMobItems.some((menu) => menu.classList.contains("open"));

	header.classList.toggle("fixed", isFixed);

	if (!isFixed || isMenuOpen || currentScrollY < lastScrollY) {
		clearTimeout(hideTimeout);
		hideTimeout = null;
		header.classList.remove("hide");
	} else if (currentScrollY > lastScrollY && currentScrollY > headerHeight && !hideTimeout) {
		hideTimeout = setTimeout(() => {
			header.classList.add("hide");
			hideTimeout = null;
		}, hideDelay);
	}

	lastScrollY = currentScrollY;
}

let ticking = false;
function handleStickyOnScroll() {
	if (ticking) {
		return;
	}

	ticking = true;
	requestAnimationFrame(() => {
		setHeaderSticky();
		ticking = false;
	});
}

function scrollToSection(event) {
	if (!(event.target instanceof Element)) {
		return;
	}

	const link = event.target.closest('a[href^="#"]');
	if (!link) {
		return;
	}

	const href = link.getAttribute("href");
	if (!href || href === "#") {
		return;
	}

	let sectionId;
	try {
		sectionId = decodeURIComponent(href.slice(1));
	} catch (error) {
		return;
	}

	const section = document.getElementById(sectionId);
	if (!section) {
		return;
	}

	event.preventDefault();
	updateHeaderHeight();

	const sectionTop = section.getBoundingClientRect().top + window.scrollY;
	const offsetTop = Math.max(0, sectionTop - headerHeight + sectionOffset);

	window.scrollTo({
		top: offsetTop,
		behavior: "smooth",
	});

	closeMobileMenu();
}

function openMenuMobile(event) {
	if (event) {
		event.preventDefault();
	}

	if (!menuMob || !toggleMenu) {
		return;
	}

	const isOpen = menuMobItems.some((menu) => menu.classList.contains("open") && !menu.classList.contains("is-closing"));
	if (isOpen) {
		closeMobileMenu({ restoreFocus: true });
		return;
	}

	menuTrigger = toggleMenu;
	header?.classList.remove("hide");
	menuMobItems.forEach((menu) => {
		menu.classList.add("open");
		menu.classList.remove("is-closing");
	});
	htmlOpen.classList.add("menu-active");
	toggleMenu.classList.add("active");
	toggleMenu.setAttribute("aria-expanded", "true");
	toggleMenu.setAttribute("aria-label", "Fechar menu");
	setMobileMenusInert(false);

	const timeline = getMobileMenuTimeline();
	if (timeline) {
		timeline.play();
	} else {
		requestAnimationFrame(() => menuMob.querySelector("a")?.focus());
	}
}

function handleKeyboardNavigation(event) {
	if (event.key === "Escape") {
		closeMobileMenu({ restoreFocus: true });
	}
}

function syncMenuAccessibility() {
	if (!menuMob) return;

	if (!mobileMenuQuery.matches) {
		mobileMenuTimeline?.kill();
		mobileMenuTimeline = null;
		resetMobileMenuVisualState();
		setMobileMenusInert(false);

		if (typeof gsap !== "undefined") {
			gsap.set([...menuMobItems, ...getMobileMenuLinks()].filter(Boolean), { clearProps: "all" });
		}
		return;
	}

	menuMobItems.forEach((menu) => {
		menu.inert = !menu.classList.contains("open");
	});
}

function initServicesCardsScroll() {
	const servicesCards = document.querySelector(".servicesCards");
	if (!servicesCards) {
		return;
	}

	const cards = [...servicesCards.querySelectorAll("li")];
	if (cards.length <= 1) {
		return;
	}

	const dots = document.createElement("div");
	dots.className = "servicesCardsDots";
	dots.setAttribute("aria-label", "Navegação dos serviços");

	const dotButtons = cards.map((card, index) => {
		const button = document.createElement("button");
		button.type = "button";
		button.setAttribute("aria-label", `Ver serviço ${index + 1}`);

		button.addEventListener("click", () => {
			servicesCards.scrollTo({
				left: card.offsetLeft,
				behavior: "smooth",
			});
		});

		dots.appendChild(button);
		return button;
	});

	servicesCards.insertAdjacentElement("afterend", dots);

	function updateActiveDot() {
		if (!servicesCardsQuery.matches) {
			dotButtons.forEach((button) => button.classList.remove("active"));
			return;
		}

		const currentIndex = cards.reduce((activeIndex, card, index) => {
			const activeDistance = Math.abs(cards[activeIndex].offsetLeft - servicesCards.scrollLeft);
			const cardDistance = Math.abs(card.offsetLeft - servicesCards.scrollLeft);
			return cardDistance < activeDistance ? index : activeIndex;
		}, 0);

		dotButtons.forEach((button, index) => {
			button.classList.toggle("active", index === currentIndex);
			button.setAttribute("aria-current", index === currentIndex ? "true" : "false");
		});
	}

	servicesCards.addEventListener("scroll", () => {
		requestAnimationFrame(updateActiveDot);
	}, { passive: true });

	servicesCardsQuery.addEventListener("change", updateActiveDot);
	updateActiveDot();
}


window.addEventListener("scroll", handleStickyOnScroll, { passive: true });
window.addEventListener("resize", updateHeaderHeight, { passive: true });
window.addEventListener("keydown", handleKeyboardNavigation);
document.addEventListener("click", scrollToSection);
toggleMenu?.addEventListener("click", openMenuMobile);
mobileMenuQuery.addEventListener("change", () => {
	closeMobileMenu();
	syncMenuAccessibility();
});
function initProjectsArchiveFilters() {
	const archive = document.querySelector("#projectsArchive");
	const filters = archive?.querySelector(".projectsArchive__filters");
	const cards = [...(archive?.querySelectorAll(".projectsArchive__grid > li") || [])]
		.map((element) => ({ element, services: (element.dataset.servicos || "").split(" ") }));
	if (!filters || !cards.length) return;

	const buttons = [...filters.querySelectorAll("button[data-servico]")];
	filters.addEventListener("click", (event) => {
		const selected = event.target.closest("button[data-servico]");
		if (!selected || !filters.contains(selected) || selected.classList.contains("active")) return;

		buttons.forEach((button) => {
			const active = button === selected;
			button.classList.toggle("active", active);
			button.setAttribute("aria-pressed", String(active));
		});

		cards.forEach(({ element, services }) => {
			element.hidden = selected.dataset.servico !== "" && !services.includes(selected.dataset.servico);
		});
	});
}

function initSite() {
	const initializers = [
		initProjectsArchiveFilters,
		initSmoothPageScroll,
		syncMenuAccessibility,
		initServicesCardsScroll,
		updateHeaderHeight,
		setHeaderSticky,
		initBannerAnimation,
		initBannerLPAnimation,
		initEvolutionLPAnimation,
		initHatLinesAnimation,
		initServicesAnimation,
		initDeliverAnimation,
		initControlAnimation,
		initInstitutionalCycleAnimation,
		initAboutAnimation,
		initAboutInsideAnimation,
		initAegfPageAnimation,
		initObrasPageAnimation,
		initContextAnimation,
		initSecurityAnimation,
		initAreasAnimation,
		initAreasInsideAnimation,
		initPartnersAnimation,
		initTeamAnimation,
		initTeamSwiper,
		initArticlesSwiper,
		initServicesExecutedSwiper,
		initProjectGallerySwiper,
		() => initProjectGallerySwiper("#projectVideoGallerySwiper", "#projectVideoGalleryModal"),
		initBoxNewsAnimation,
		initBoxArticlesAnimation,
		initBlogAnimation,
		initBlogArchiveAnimation,
		initBlogDetailAnimation,
		initProjectsIntroAnimation,
		initProjectsLogoAnimation,
		initProjectsCardsAnimation,
		initProjectDetailAnimation,
		initContactAnimation,
		initNewsletterAnimation,
		initFooterAnimation,
	];

	initializers.forEach((initializer) => {
		try {
			initializer();
		} catch (error) {
			console.error(`Falha ao inicializar ${initializer.name}:`, error);
		}
	});
}

queueMicrotask(initSite);
